import { ConfigProvider } from 'antd';
import { ApolloProvider } from '@apollo/client';
import { container } from '../apollo-client/container';
import { theme } from '@/lib/antd/antd-theme';
import '../../shared/components/antd/notification/notification';
import ChargebeeProvider from './chargebee/chargebee-context';

export default function PublicProviders({ children }: { children: JSX.Element }) {
  return (
    <ApolloProvider client={container.apolloClient}>
      <ConfigProvider theme={theme}>
        <ChargebeeProvider>{children}</ChargebeeProvider>
      </ConfigProvider>
    </ApolloProvider>
  );
}
